import { useParams, Link } from "react-router-dom";
import { packages } from "../data/packages"; // local data
import RecommendedPackages from "../components/RecommendedPackages";
import StarRating from "../components/StarRating";
import "./PackageDetails.css";

export default function PackageDetails() {
  const { category, id } = useParams();

  // Find the package by converting id to string for correct comparison
  const pkg = packages[category]?.find((p) => p.id.toString() === id);

  if (!pkg) return <p className="not-found">Package not found</p>;

  // Split long description into lines if available
  const descriptionLines = pkg.longDescription?.split("\n") || [];

  return (
    <section className="package-details">
      {/* Package Detail Card */}
      <div className="package-detail-card">
        <div className="detail-layout">
          {/* Image */}
          <div className="detail-image-wrapper">
            <img src={pkg.image} alt={pkg.title} className="detail-image" />
            <div className="image-caption">{category.toUpperCase()} PACKAGE</div>
          </div>

          {/* Text Section */}
          <div className="detail-text">
            <h2>{pkg.title}</h2>

            {/* Star rating */}
            <div className="rating-block">
              <StarRating rating={pkg.rating || 0} readOnly={true} size={20} />
            </div>

            {/* Description */}
            <div className="description">
              {descriptionLines.map((line, idx) => (
                <p key={idx}>{line}</p>
              ))}
            </div>

            {/* Action Buttons */}
            <div className="detail-actions">
              <Link to="/contact" className="btn-readmore">
                Customize This Package
              </Link>
              <Link to={`/packages/${category}`} className="btn-back">
                ← Back to {category.charAt(0).toUpperCase() + category.slice(1)} Packages
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Recommended Packages */}
      <RecommendedPackages category={category} />
    </section>
  );
}
